import getCurrentBrand from "./getCurrentBrand";

export default predefined => JSON.stringify({
  "guest_form": {
    "name": {
      "editable": false,
      "visible": false,
      "value": predefined.name,
    },
    "email": {
      "editable": false,
      "visible": false,
      "value": predefined.email,
    },
  },
  "question_form": {
    "custom_fields": {
      "country": {
        "visible": false,
        "editable": false,
        "value": "", // @todo 2018-10-09 ?
      },
      "sa-boutique": {
        "visible": false,
        "editable": false,
        "value": predefined.saBoutique,
      },
      "sa-username": {
        "visible": true,
        "editable": false,
        "value": predefined.saUsername
      },
      "request-type": {
        "visible": true,
        "editable": true,
        "value": [
          "This user moved to another store (please specify)",
          "This user is no longer working at Valentino",
          "Other"
        ],
      },
      "attachment": {
        "visible": true,
        "editable": true
      },
      "brand": {
        "visible": false,
        "editable": false,
        "value": getCurrentBrand()
      },
    },
  },
});
